import type { FinanceForecastRow } from './ForecastTable';

export type FinanceCompareMode =
  | 'none'
  | 'previous_period'
  | 'previous_year'
  | 'custom';

function findCompareColumnIndex(
  period: string,
  comparePeriods: string[],
  compareMode: FinanceCompareMode,
  columnIndex: number,
): number {
  if (compareMode === 'previous_year') {
    const yearMatch = period.match(/^(\d{4})(-\d{2}(?:-\d{2})?)?$/);
    if (yearMatch) {
      const target = `${Number(yearMatch[1]) - 1}${yearMatch[2] ?? ''}`;
      const byLabel = comparePeriods.indexOf(target);
      if (byLabel >= 0) return byLabel;
    }
  }

  if (columnIndex < comparePeriods.length) return columnIndex;
  return -1;
}

export function attachCompareToFinanceRows(
  rows: FinanceForecastRow[],
  periods: string[],
  compareRows: FinanceForecastRow[],
  comparePeriods: string[],
  compareMode: FinanceCompareMode,
): FinanceForecastRow[] {
  if (!compareRows.length || !comparePeriods.length || compareMode === 'none') {
    return rows;
  }

  const compareByKey = new Map(compareRows.map((row) => [row.metricKey, row]));

  return rows.map((row) => {
    if (row.emphasis === 'section' || row.emphasis === 'spacer') {
      return row;
    }

    const compareRow = compareByKey.get(row.metricKey);
    if (!compareRow) {
      return { ...row, compareValues: periods.map(() => null) };
    }

    const compareValues = periods.map((period, index) => {
      const compareIndex = findCompareColumnIndex(
        period,
        comparePeriods,
        compareMode,
        index,
      );
      if (compareIndex < 0) return null;
      const value = compareRow.values[compareIndex];
      return Number.isFinite(value) ? value : null;
    });

    return { ...row, compareValues };
  });
}
